import React, { useContext, useEffect } from "react";
import resolveLink from "src/utils/resolveLink";
import Heading from "src/components/Heading";
import RichText from "src/utils/RichText";
import { useForm } from "react-hook-form";
import { navigate } from "gatsby";
import SbEditable from "storyblok-react";

import TextInput from "./Forms/Components/TextInput";
import EmailInput from "./Forms/Components/EmailInput";
import TextAreaInput from "./Forms/Components/TextAreaInput";
import FileInput from "./Forms/Components/FileInput";
import NumberInput from "./Forms/Components/NumberInput";
import SelectInput from "./Forms/Components/SelectInput";
import RadioButtons from "./Forms/Components/RadioButtons";
import Checkboxes from "./Forms/Components/Checkboxes";
import ConsentInput from "./Forms/Components/ConsentInput";
import CtaReferrer from "./Forms/Components/CtaReferrer";

import CookieValue from "src/utils/CookieValue";
import { PageContext } from "src/utils/context";
import { useCookies } from "react-cookie";

const Components = {
  "text-input": TextInput,
  "email-input": EmailInput,
  "textarea-input": TextAreaInput,
  "file-input": FileInput,
  "number-input": NumberInput,
  "select-input": SelectInput,
  "radio-buttons": RadioButtons,
  checkboxes: Checkboxes,
  "consent-input": ConsentInput,
  "cta-referrer": CtaReferrer,
};

const Form = ({ blok }) => {
  const [cookies] = useCookies();
  const gclid = cookies.gclid;

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();

  function encode(data) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (typeof value === "object" && value !== null) {
        formData.append(key, value[0]);
      } else {
        formData.append(key, value);
      }
    }
    return formData;
  }

  // Getting the gated content data
  const { gatedContentAllowed, setGatedContentAllowed, ctaReferrer, location } =
    useContext(PageContext);

  const redirectUrl = CookieValue("gated_content_redirect_url");

  const onSubmit = (data) => {
    data.page_referrer = location?.state?.referrer || null
    // If the form is for gated content
    if (blok.gated_content_form) {
      if (!gatedContentAllowed) {
        data.cta_referrer = ctaReferrer;
        setGatedContentAllowed(true);
        window?.dataLayer?.push({
          event: "form-submission",
          formName: "gated-content",
        });
        if (redirectUrl) {
          window.open(redirectUrl, "noopener,noreferrer");
        }
      }
    }
    fetch("/", {
      method: "POST",
      body: encode(data),
    })
      .then(() => {
        window?.dataLayer?.push({
          event: "form-submission",
          formName: blok.name,
        });
        navigate(resolveLink(blok.action.cached_url));
      })
      .catch((error) => console.log(error));
  };

  return (
    <SbEditable content={blok}>
      <div className="bg-white">
        <div className="mx-auto my-16 max-w-[840px] px-6">
          {/* <div className="mx-auto max-w-xl">
            {blok.title && (
              <Heading size={blok.smaller_title ? "h3" : "h2"}>
                {console.log(blok?.title,"oasuhuisahduihduiahduiahduih")}
                {blok.title}
              </Heading>
            )}
            {blok.description && (
              <div className="prose text-sm md:text-base">
                {console.log(blok.description)}
                <RichText>{blok.description}</RichText>
              </div>
            )}
          </div> */}
          <form
            onSubmit={handleSubmit(onSubmit)}
            name={blok.name}
            id={blok.name}
            className="mx-auto mt-12 flex flex-col 2xl:max-w-3xl"
            data-netlify="true"
          >
            <div className="grid grid-cols-6 gap-x-4">
              {blok.fields.map((field, index) => {
                const Component = Components[field.component];
                return (
                  <Component
                    blok={field}
                    register={register}
                    watch={watch}
                    errors={errors}
                    key={index}
                  />
                );
              })}
            </div>
            <input
              {...register("form-name")}
              type="hidden"
              name="form-name"
              value={blok.name}
            />
            <input
              type="text"
              className="hidden"
              name="gclid"
              value={gclid}
              {...register("gclid")}
            />
            <input
              type="text"
              className="hidden"
              name="page_referrer"
              value={location?.state?.referrer}
              {...register("page_referrer")}
            />
            <button
              type="submit"
              before={blok.button_text}
              className="font-display bg-brightgreen hover:bg-brightgreenhover relative inline-block h-[46px] cursor-pointer items-center self-end overflow-hidden rounded-lg !px-[45px] py-[13px] px-4 text-sm font-semibold tracking-[-0.5px] text-white transition-all duration-300 ease-in-out before:absolute before:-top-10 before:content-[attr(before)] hover:leading-[9em] lg:mb-1"
            >
              {blok.button_text}
            </button>
          </form>
        </div>
      </div>
    </SbEditable>
  );
};

export default Form;
